import React from 'react';
import PropTypes from 'prop-types';
import { Button, Input } from '@gasbuddy/react-components';
import PriceProps from '../../../utils/prop-types/price';
import styles from './styles.css';
import { formatPrice } from './price-item';

const { gTagEvent } = require('../../../../lib/global-site-tag').default;

class UpdatePrice extends React.Component {
  static propTypes = {
    price: PriceProps.isRequired,
    currentStationPrice: PriceProps.isRequired,
    country: PropTypes.string.isRequired,
    onPriceBlur: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      price: props.price,
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { country, price } = this.props;
    const { price: priceState } = this.state;

    return (nextProps.country !== country) || (nextProps.price.price !== price.price)
      || (nextState.price.price !== priceState.price.price);
  }

  setPriceInState = (newPrice) => {
    this.setState(prevState => ({ price: { ...prevState.price, price: Number(newPrice) } }));
  };

  onConfirmPriceClick = () => {
    const { currentStationPrice: { price } } = this.props;
    gTagEvent('EDIT PRICES Popup', 'Confirm Price');
    this.props.onPriceBlur(price);
    this.setPriceInState(price);
  }

  onPriceChange = (event) => {
    // USA -> Dollars format; CA & AUS -> Cents format
    const formattedPrice = (this.props.country === 'US' ? this.applyDollarsFormat(event.target.value) : this.applyCentsFormat(event.target.value));

    this.setPriceInState(formattedPrice);
  }

  onPriceBlur = (event) => {
    this.props.onPriceBlur(event.target.value);
  }

  formatPriceString = (priceText, digitsBeforePeriod, maxLength) => {
    const price = priceText.replace('.', '');
    return `${price.slice(0, digitsBeforePeriod)}${price.length > digitsBeforePeriod ? '.' : ''}${price.slice(digitsBeforePeriod, maxLength)}`;
  };

  applyCentsFormat = (priceText) => {
    let digitsBeforePeriod = 2;

    if (priceText.startsWith('1') || priceText.startsWith('2')) {
      digitsBeforePeriod = 3;
    }

    return this.formatPriceString(priceText, digitsBeforePeriod, 4);
  }

  applyDollarsFormat = priceText => this.formatPriceString(priceText, 1, 3);

  hasPeriod = text => text.includes('.');

  render() {
    // grab from props to populate buttons
    const { currentStationPrice: { price: currentStationPrice }, country } = this.props;
    // grab from state for input values
    const { price: { price: priceFromState } } = this.state;
    return (
      <div className={styles.priceInputContainer}>
        <Input
          placeholder="Enter Price"
          value={priceFromState > 0 ? priceFromState.toString() : ''}
          type="string"
          onChange={this.onPriceChange}
          onBlur={this.onPriceBlur}
          mask={country === 'US' ? /^\d?\.?\d{0,2}$/g : /^\d{0,3}\.?\d?$/g}
        />
        {currentStationPrice
          ? (
            <Button color="teal" onClick={this.onConfirmPriceClick}>
              {`Confirm ${formatPrice(currentStationPrice, country)}`}
            </Button>
          )
          : ''
        }
      </div>
    );
  }
}

export default UpdatePrice;
